import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../LoginForm';

const StudioRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  
  // If user is authenticated, redirect to tools page
  if (isAuthenticated) {
    return <Navigate to="/studio/tools" replace />;
  }
  
  // If user is not authenticated, show login form
  return <LoginForm />;
};

export default StudioRedirect;